<div class="modal" id="mapStops" tabindex="-1">
	<div class="modal-dialog modal-lg modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-body">
				<div class="btn btn-primary mb-4 me-4" *ngFor="let item of data" (click)="select(item)">
					{{ item.name }}<br />
					<small>{{ item.address }}</small>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>
			</div>
		</div>
	</div>
</div>
